export function getRandomEnum<T extends { [k: string | number]: unknown }>(
  anEnum: T,
): T[keyof T] {
  const values = Object.keys(anEnum);
  return anEnum[
    values[Math.floor(Math.random() * values.length)]
  ] as T[keyof T];
}
